module.exports = __webpack_public_path__ + "img/78.09647b6e.jpg";